module.exports = __webpack_public_path__ + "assets/htu-1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/HTU-modal/htu-1.jpg
// module id = 1188
// module chunks = 7